var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"gender-filter"},[_c('sk-multiselect',{attrs:{"items-list":_vm.genderTypes,"preselected-value":_vm.selectedGenders,"default-value":_vm.placeholder},on:{"checkboxeschanged":_vm.onInputBoxChanged}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }